import React from 'react';
import { TrialHero } from '../components/trial/TrialHero';
import { TrialDetails } from '../components/trial/TrialDetails';
import { TrialForm } from '../components/trial/TrialForm';
export function TrialPage() {
  return <main className="bg-gray-50 min-h-screen pb-20" data-id="element-575">
      <TrialHero data-id="element-576" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-10" data-id="element-577">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-578">
          {/* Left Column: Details */}
          <div className="lg:col-span-7 order-2 lg:order-1" data-id="element-579">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 h-full" data-id="element-580">
              <TrialDetails data-id="element-581" />
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-5 order-1 lg:order-2" data-id="element-582">
            <div className="sticky top-24" data-id="element-583">
              <TrialForm data-id="element-584" />
            </div>
          </div>
        </div>
      </div>
    </main>;
}